// "Staging" enabled environment

export const environment = {
    production: false,
    hmr: false,
    appConfig: 'appconfig.staging.json',
    ndihUrl: 'https://nodeinnovationhub.nodetest.it',
};
